namespace Matrix.Data {

    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class SecurityValuesDialog extends Serenity.TemplatedDialog<any> {

        public grid: SecurityValuesGrid;

        constructor() {
            super();

            this.grid = new SecurityValuesGrid(this.element.children());
        }

        protected getTemplate() {
            return "<div style='height: 100%; flex: 1 1 100%;'></div>";
        }
    }
}